export default __webpack_public_path__ + "static/media/Graphics_FB-Cover-page-updated-min.4124f492.png";